import Page403 from 'pages/Page403';
import Identity from 'store/identity.entity';
import { h } from 'vue';

export default function PageAccess (component, perm, forbidden = Page403) {
  return {
    render () {
      return Identity.can(perm) ? h(component) : h(forbidden);
    },
  };
}
